<template>
    <div class="v-alert">
        <header><p>New Wallet</p><div @click="exit()" class="x"></div></header>
        <p class="message">New Wallet Nane</p>
        <input v-model:value="input" />
        <div class="v-btns">
            <p class="btn gr" @click="exit()">cancel</p>
            <p class="btn" @click="newWallet(input)">OK</p>
        </div>	
    </div>
</template>

<script>

import Alert from '@/utils/Alert.js'

export default {
    name: 'new-wallet',
    data () {
        return {
            input: ''
        }
    },
    mounted () {
       
    },
    methods: {
        exit () {
            this.$router.push('/');
        },
        newWallet ( title ) {

            if ( !title ) return Alert.message('You must provide a name for the wallet');

            var wallet = {
                client_id: this.client_id,
                title,
                qtySent: 0,
                opens: 0,
                uniqueOpens: {},
                cards: []
            };

            WebSoc.SEND('newWallet',{ wallet },resp => {
                this.$router.push('/wallets');
            })

        }
    }
}

</script>